const MAPBOX_CARD_WIDTH = 360;
const MAPBOX_CARD_NARROW_HEIGHT = 350;

export { MAPBOX_CARD_WIDTH, MAPBOX_CARD_NARROW_HEIGHT };
